
<div [ngClass]="loading ? 'edit-user-container-loading' : 'edit-user-container'">
  @if (!loading) {
    <div class="edit-user-header">
      <h1>Editing {{userName}} Profile</h1>
      <span class="edit-user-header-buttons-container">
        <button mat-button matTooltip="Cancel Editing" id="btnCancel" class="inverse-button" (click)="onCancelEditing()">
          Cancel
        </button>
        <button mat-button matTooltip="Save Editing" id="btnSave" class="regular-button" style="margin-left: 0.5rem;"
          (click)="onSavingGeneralInfo()">
          Update
        </button>
      </span>
    </div>
  }
  @if (!loading) {
    <form [formGroup]="userInfoForm">
      @if (isAdmin || isDeveloper) {
        <mat-accordion  class="supervisor-accordion">
          <mat-expansion-panel>
            <!-- Header: only the bold title -->
            <mat-expansion-panel-header class="supervisor-header">
              <mat-panel-title class="panel-title">
                Supervisor &nbsp;:&nbsp; <input
                matInput
                type="text" class="no-border"
                [disabled]="true"
                formControlName="supervisorName"
                aria-label="Current Supervisor Name"
                />
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="panel-body">
              <div class="subheading">Change Supervisor?</div>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>New Supervisor</mat-label>
                <input
                  type="text"
                  matInput
                  (input)="searchUser($any($event.target).value)"
                  [matAutocomplete]="autosup"
                  formControlName="newSupervisorName"
                  aria-autocomplete="list"
                  aria-label="Search Employee"
                  />
                  <mat-autocomplete
                    #autosup="matAutocomplete"
                    [displayWith]="displayUserItem"
                    (optionSelected)="onSuggestionChanged($event)"
                    autoActiveFirstOption
                    >
                    @for (_user of users$ | async; track _user) {
                      <mat-option [value]="_user">
                        {{ _user.firstName }} {{ _user.lastName }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
        <div class="edit-user-info-container">
          <h2>General Information</h2>
          <div class="edit-user-info-sub-container">
            <span class="edit-user-info-input-container">
              <mat-form-field id="infoInput" appearance="outline">
                <mat-label>First Name</mat-label>
                <input matInput type="text" formControlName="firstname">
              </mat-form-field>
              <mat-form-field id="infoInput" appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput type="text" formControlName="lastname">
              </mat-form-field>
            </span>
            <span class="edit-user-info-input-container">
              <mat-form-field id="infoInput" appearance="outline">
                <mat-label>JobTitle</mat-label>
                <input matInput type="text" formControlName="jobtitle">
              </mat-form-field>
              <mat-form-field id="infoInput" appearance="outline">
                <mat-label>Company</mat-label>
                <mat-select formControlName="companyid">
                  @for (company of companies; track company) {
                    <mat-option [value]="company.ID">
                      {{company.Name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </span>
            <span class="edit-user-info-input-container">
              <mat-form-field id="infoInput" appearance="outline">
                <mat-label>Division</mat-label>
                <mat-select formControlName="divisionid"  style="height: 25px;" (selectionChange)="onChangingDivision()">
                  <!-- <mat-option>--None--</mat-option> -->
                  @for (division of divisions; track division) {
                    <mat-option [value]="division.ID">
                      {{division.Name}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="sectionmatsize">
                <mat-label>Search Section</mat-label>
                <input width="100%"
                  type="text"
                  matInput
                  (input)="search($any($event.target).value)"
                  [matAutocomplete]="auto"
                  formControlName="itemCtrl"
                  aria-autocomplete="list" />
                  <mat-autocomplete width="100%"
                    #auto="matAutocomplete" [displayWith]="displayItem"
                    (optionSelected)="onSelected($event.option.value)"
                    >
                    @for (i of filteredItems$ | async; track i) {
                      <mat-option [value]="i">
                        {{ i.Name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </span>
              <span class="edit-user-info-input-container">
                <mat-form-field id="infoInput" appearance="outline">
                  <mat-label>Call Sign Format(ex: A0-1, A53, A53-1, 53-1,A 53)</mat-label>
                  <input matInput type="text" formControlName="callsign">
                </mat-form-field>
                <!-- Work Days Group (no fieldset/legend) -->
                <div
                  class="workday-group"
                  role="group"
                  aria-labelledby="workdayLabel"
                  aria-required="true"
                  >
                  <!-- Material-style label (outside mat-form-field) -->
                  <span class="mat-subtitle-2 workday-label" id="workdayLabel">
                    Work Day <span class="required-asterisk" aria-hidden="true">*</span>
                  </span>
                  <div class="workday-toggles">
                    <mat-slide-toggle
                      class="toggle"
                      id="monday"
                      (change)="onChangeOfToggleWorkDay($event,'po','pt','npo','npt','monday')"
                      formControlName="monday"
                      >
                      Mon
                    </mat-slide-toggle>
                    <mat-slide-toggle
                      class="toggle"
                      id="tuesday"
                      (change)="onChangeOfToggleWorkDay($event,'po','pt','npo','npt','tuesday')"
                      formControlName="tuesday"
                      >
                      Tue
                    </mat-slide-toggle>
                    <mat-slide-toggle
                      class="toggle"
                      id="wednesday"
                      (change)="onChangeOfToggleWorkDay($event,'po','pt','npo','npt','wednesday')"
                      formControlName="wednesday"
                      >
                      Wed
                    </mat-slide-toggle>
                    <mat-slide-toggle
                      class="toggle"
                      id="thursday"
                      (change)="onChangeOfToggleWorkDay($event,'po','pt','npo','npt','thursday')"
                      formControlName="thursday"
                      >
                      Thu
                    </mat-slide-toggle>
                    <mat-slide-toggle
                      class="toggle"
                      id="friday"
                      (change)="onChangeOfToggleWorkDay($event,'po','pt','npo','npt','friday')"
                      formControlName="friday"
                      >
                      Fri
                    </mat-slide-toggle>
                    <mat-slide-toggle
                      class="toggle"
                      id="saturday"
                      (change)="onChangeOfToggleWorkDay($event,'po','pt','npo','npt','saturday')"
                      formControlName="saturday"
                      >
                      Sat
                    </mat-slide-toggle>
                    <mat-slide-toggle
                      class="toggle"
                      id="sunday"
                      (change)="onChangeOfToggleWorkDay($event,'po','pt','npo','npt','sunday')"
                      formControlName="sunday"
                      >
                      Sun
                    </mat-slide-toggle>
                  </div>
                </div>
              </span>
              <span class="edit-user-info-input-container edit-user-info-work-hours-input-container">
                <span  id="infoWorkDaysInput">
                  <div class="divpadtopbottom">
                    <mat-form-field id="infoInput" appearance="outline">
                      <mat-label>Start Time</mat-label>
                      <mat-select  formControlName ="starttimeControl">
                        @for (hr of hourlist; track hr) {
                          <mat-option [value]="hr.value">
                            {{hr.label}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field id="infoInput" appearance="outline">
                      <mat-label>AM/PM</mat-label>
                      <mat-select   formControlName ="starttimeAMPMControl">
                        @for (ampm of ampmlist; track ampm) {
                          <mat-option [value]="ampm">
                            {{ampm}}
                          </mat-option>
                        }
                      </mat-select >
                    </mat-form-field>
                  </div>
                </span>
                <span  id="infoWorkDaysInput">
                  <div class="divpadtopbottom">
                    <mat-form-field id="infoInput" appearance="outline">
                      <mat-label id="labelendtime">End Time</mat-label>
                      <mat-select   formControlName ="endtimeControl">
                        @for (hr of hourlist; track hr) {
                          <mat-option [value]="hr.value">
                            {{hr.label}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field id="infoInput" appearance="outline">
                      <mat-label>AM/PM</mat-label>
                      <mat-select formControlName ="endtimeAMPMControl">
                        @for (ampm of ampmlist; track ampm) {
                          <mat-option [value]="ampm">
                            {{ampm}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </span>
              </span>
              @if (hasTelework) {
                <span>
                  <div>
                    <h3>Telework Schedule</h3>
                  </div>
                </span>
              }
              @if (hasTelework) {
                <span class="edit-user-info-input-container">
                  <span id="infoWorkDaysInput">
                    <fieldset><legend> Pay Week * <button matTooltip="Copy to Non Pay Week" mat-raised-button (click) ="onCopy(true)"> <mat-icon>content_copy</mat-icon><mat-icon>arrow_forward</mat-icon></button></legend>
                    <div class="divtoggleofficetelework">
                      <label id="fieldWorkLabel">In Office </label>
                      <span>
                        <mat-slide-toggle class="marginright10" id="pomonday" (change)="onChangeOfToggleWeek($event,'po','pt','monday')" formControlName="pomonday">Mon</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10" id="potuesday" (change)="onChangeOfToggleWeek($event,'po','pt','tuesday')"  formControlName="potuesday">Tue</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10" id="powednesday" (change)="onChangeOfToggleWeek($event,'po','pt','wednesday')"   formControlName="powednesday">Wed</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10" id="pothursday" (change)="onChangeOfToggleWeek($event,'po','pt','thursday')"   formControlName="pothursday">Thu</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10" id="pofriday" (change)="onChangeOfToggleWeek($event,'po','pt','friday')"  formControlName="pofriday">Fri</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10" id="posaturday" (change)="onChangeOfToggleWeek($event,'po','pt','saturday')"   formControlName="posaturday">Sat</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10" id="posunday" (change)="onChangeOfToggleWeek($event,'po','pt','sunday')"  formControlName="posunday">Sun</mat-slide-toggle>
                      </span>
                    </div>
                    <div class="divtoggleofficetelework">
                      <label id="fieldWorkLabel">Telework </label>
                      <span>
                        <mat-slide-toggle class="marginright10"  id="ptmonday" (change)="onChangeOfToggleWeek($event,'pt','po','monday')"   formControlName="ptmonday">Mon</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10"  id="pttuesday" (change)="onChangeOfToggleWeek($event,'pt','po','tuesday')" formControlName="pttuesday">Tue</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10"  id="ptwednesday" (change)="onChangeOfToggleWeek($event,'pt','po','wednesday')"  formControlName="ptwednesday">Wed</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10"  id="ptthursday" (change)="onChangeOfToggleWeek($event,'pt','po','thursday')"  formControlName="ptthursday">Thu</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10"  id="ptfriday" (change)="onChangeOfToggleWeek($event,'pt','po','friday')" formControlName="ptfriday">Fri</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10"  id="ptsaturday" (change)="onChangeOfToggleWeek($event,'pt','po','saturday')" formControlName="ptsaturday">Sat</mat-slide-toggle>
                        <mat-slide-toggle class="marginright10"  id="ptsunday" (change)="onChangeOfToggleWeek($event,'pt','po','sunday')"  formControlName="ptsunday">Sun</mat-slide-toggle>
                      </span>
                    </div>
                  </fieldset>
                </span>
                <span id="infoWorkDaysInput">
                  <fieldset><legend>Non Pay Week * <button mat-raised-button matTooltip="Copy to Pay Week" (click) ="onCopy(false)"><mat-icon>arrow_back</mat-icon> <mat-icon>content_copy</mat-icon></button></legend>
                  <div class="divtoggleofficetelework">
                    <label id="fieldWorkLabel">In Office</label>
                    <span>
                      <mat-slide-toggle class="marginright10" id="npomonday" (change)="onChangeOfToggleWeek($event,'npo','npt','monday')"  style="width: 25px;" formControlName="npomonday">Mon</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10"  id="npotuesday" (change)="onChangeOfToggleWeek($event,'npo','npt','tuesday')" formControlName="npotuesday">Tue</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10" id="npowednesday" (change)="onChangeOfToggleWeek($event,'npo','npt','wednesday')"  formControlName="npowednesday">Wed</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10" id="npothursday" (change)="onChangeOfToggleWeek($event,'npo','npt','thursday')"   formControlName="npothursday">Thu</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10" id="npofriday" (change)="onChangeOfToggleWeek($event,'npo','npt','friday')" formControlName="npofriday">Fri</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10" id="nposaturday" (change)="onChangeOfToggleWeek($event,'npo','npt','saturday')"  formControlName="nposaturday">Sat</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10" id="nposunday" (change)="onChangeOfToggleWeek($event,'npo','npt','sunday')" formControlName="nposunday">Sun</mat-slide-toggle>
                    </span>
                  </div>
                  <div class="divtoggleofficetelework">
                    <label id="fieldWorkLabel">Telework</label>
                    <span>
                      <mat-slide-toggle class="marginright10"   id="nptmonday" (change)="onChangeOfToggleWeek($event,'npt','npo','monday')"   formControlName="nptmonday">Mon</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10"  id="npttuesday" (change)="onChangeOfToggleWeek($event,'npt','npo','tuesday')" formControlName="npttuesday">Tue</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10"  id="nptwednesday" (change)="onChangeOfToggleWeek($event,'npt','npo','wednesday')" formControlName="nptwednesday">Wed</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10"  id="nptthursday" (change)="onChangeOfToggleWeek($event,'npt','npo','thursday')" formControlName="nptthursday">Thu</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10"  id="nptfriday" (change)="onChangeOfToggleWeek($event,'npt','npo','friday')"  formControlName="nptfriday">Fri</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10"  id="nptsaturday" (change)="onChangeOfToggleWeek($event,'npt','npo','saturday')" formControlName="nptsaturday">Sat</mat-slide-toggle>
                      <mat-slide-toggle class="marginright10"  id="nptsunday" (change)="onChangeOfToggleWeek($event,'npt','npo','sunday')"  formControlName="nptsunday">Sun</mat-slide-toggle>
                    </span>
                  </div>
                </fieldset>
              </span>
            </span>
          }
          <span><div>
            <label id="lblerror" class="error-message"> {{errorMessage}}</label>
          </div></span>
          <span class="edit-user-info-input-container edit-user-info-work-hours-input-container" style="padding-bottom: 10px;">
            @if (isAdmin || isDeveloper) {
              <span id="infoSpecialAccessInput">
                <br/>
                <label id="fieldNameLabel">Special Access Settings</label>
                <span>
                  @if (isDeveloper && isActive) {
                    <mat-slide-toggle style="padding-bottom: 10px;" formControlName="isActive" (change)="OnChangeDeActive()" >Active</mat-slide-toggle>
                  }
                  @if (isAdmin || isDeveloper) {
                    <mat-slide-toggle style="padding-bottom: 10px;" formControlName="isSupervisor">Supervisor</mat-slide-toggle>
                  }
                  @if (isAdmin || isDeveloper) {
                    <mat-slide-toggle style="padding-bottom: 10px;" formControlName="isAdmin">Admin</mat-slide-toggle>
                  }
                  @if (isDeveloper) {
                    <mat-slide-toggle style="padding-bottom: 10px;" formControlName="isDeveloper">Tech Admin</mat-slide-toggle>
                  }
                  @if (isAdmin || isDeveloper) {
                    <mat-slide-toggle style="padding-bottom: 10px;" formControlName="isTelework"  (change)="onChangeOfToggleTelework()" >Telework</mat-slide-toggle>
                  }
                </span>
              </span>
            }
          </span>
        </div>
      </div>
      <div class="edit-user-info-bottom-container">
        <div class="edit-user-info-container edit-user-info-contact-container">
          <span class="edit-user-info-button-container">
            <h2>Contact Information</h2>
            <button id="addPhoneBtnDesktop" mat-button type="button" matTooltip="Add Phone"
              class="regular-button edit-user-info-add" (click)="onAddingNewDeviceRow()">
              <mat-icon>add</mat-icon>
            </button>
            <button id="addPhoneBtnMobile" mat-button type="button" matTooltip="Add Phone"
              class="regular-button edit-user-info-add" (click)="onAddingNewDeviceInMobile()">
              <mat-icon>add</mat-icon>
            </button>
          </span>
          <div class="edit-user-info-devices-table_desktop">
            <form [formGroup]="phoneDeviceInfoTable">
              <table id="devicesTableDesktop" class="phone-devices-table">
                <thead>
                  <th></th>
                  <th></th>
                  <th  class="mat-header-cell">Number</th>
                  <th  class="mat-header-cell">Type</th>
                  <th  class="mat-header-cell">Preferred</th>
                  <th  class="mat-header-cell">Visible</th>
                </thead>
                <tbody>
                  @for (row of getPhoneDeviceRows.controls; track row; let i = $index) {
                    <ng-container  formArrayName="infoRows">
                      @if (row.get('isEditable')?.value) {
                        <tr [formGroupName]="i">
                          <td class="icon-column">
                            <button type="submit" mat-icon-button matTooltip="Save Phone Device"
                              (click)="onSavingDeviceRow(i)">
                              <mat-icon>done</mat-icon>
                            </button>
                          </td>
                          <td class="icon-column">
                            <!-- <button type="button" mat-icon-button matTooltip="Delete Phone Device" (click)="onDeletingDeviceRow(i)">
                            <mat-icon>delete_outline</mat-icon>
                          </button> -->
                          <button type="button" mat-icon-button matTooltip="Cancel Edting Device"
                            (click)="onCancelingEditDeviceRow(i)">
                            <mat-icon>close</mat-icon>
                          </button>
                        </td>
                        <td>
                          <mat-form-field appearance="outline">
                            <input matInput type="text" formControlName="number" pattern="\d*" maxlength="10"
                              (keypress)="onDeviceNumberInput($event)">
                              @if (row.get('number')?.hasError) {
                                <mat-error>Number is required.</mat-error>
                              }
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-form-field appearance="outline">
                              <mat-select formControlName="typeId" (selectionChange)="onChangingDeviceType(i)">
                                @for (type of deviceTypes; track type) {
                                  <mat-option [value]="type.ID">
                                    {{type.Name}}
                                  </mat-option>
                                }
                              </mat-select>
                              @if (row.get('typeId')?.hasError) {
                                <mat-error>Device type is required.</mat-error>
                              }
                            </mat-form-field>
                          </td>
                          <td>
                            <mat-checkbox formControlName="preferred"
                            (change)="onChangingPreferredDevice($event.checked, i)"></mat-checkbox>
                          </td>
                          <td>
                            <mat-checkbox formControlName="visible"></mat-checkbox>
                          </td>
                        </tr>
                      }
                      @if (!row.get('isEditable')?.value) {
                        <tr>
                          <td class="icon-column">
                            <button type="button" mat-icon-button matTooltip="Edit Phone Device"
                              (click)="onEditingDeviceRow(i)">
                              <mat-icon>edit</mat-icon>
                            </button>
                          </td>
                          <td class="icon-column">
                            <button type="button" mat-icon-button matTooltip="Delete Phone Device"
                              (click)="onDeletingDeviceRow(i)">
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </td>
                          <td>
                            {{row.get('number')?.value | phone}}
                          </td>
                          <td>
                            {{row.get('type')?.value}}
                          </td>
                          <td>
                            @if (row.get('preferred')?.value && !row.get('isEditable')?.value) {
                              <mat-icon
                              class="check-circle">check_circle</mat-icon>
                            }
                          </td>
                          <td>
                            @if (row.get('visible')?.value && !row.get('isEditable')?.value) {
                              <mat-icon
                              class="check-circle">check_circle</mat-icon>
                            }
                          </td>
                        </tr>
                      }
                    </ng-container>
                  }
                </tbody>
              </table>
              <table id="devicesTableMobile" class="phone-devices-table">
                <thead>
                  <th></th>
                  <th></th>
                  <th class="mat-header-cell">Number</th>
                  <th></th>
                </thead>
                <tbody>
                  @for (row of getPhoneDeviceRows.controls; track row; let i = $index) {
                    <ng-container formArrayName="infoRows">
                      @if (!row.get('isEditable')?.value) {
                        <tr [ngClass]="{'row-no-border': row.get('isExpanded')?.value}">
                          <td class="icon-column">
                            <button type="button" mat-icon-button matTooltip="Edit Phone Device"
                              (click)="onEditingDeviceInMobile(i)">
                              <mat-icon>edit</mat-icon>
                            </button>
                          </td>
                          <td class="icon-column">
                            <button type="button" mat-icon-button matTooltip="Delete Phone Device"
                              (click)="onDeletingDeviceRow(i)">
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </td>
                          <td>
                            {{row.get('number')?.value | phone}}
                          </td>
                          <td class="icon-column">
                            @if (!row.get('isExpanded')?.value) {
                              <button type="button" mat-icon-button
                                matTooltip="Expand Device Details" (click)="row.get('isExpanded')?.setValue(true)">
                                <mat-icon>expand_more</mat-icon>
                              </button>
                            }
                            @if (row.get('isExpanded')?.value) {
                              <button type="button" mat-icon-button
                                matTooltip="Expand Device Details" (click)="row.get('isExpanded')?.setValue(false)">
                                <mat-icon>expand_less</mat-icon>
                              </button>
                            }
                          </td>
                        </tr>
                      }
                      @if (!row.get('isEditable')?.value && row.get('isExpanded')?.value) {
                        <tr>
                          <td colspan="4">
                            <span class="edit-user-device-expand-details">
                              <label>type:</label>
                              <span>{{row.get('type')?.value}}</span>
                            </span>
                            <span class="edit-user-device-expand-details">
                              <label>preferred:</label>
                              @if (row.get('preferred')?.value) {
                                <mat-icon class="check-circle">check_circle</mat-icon>
                              }
                            </span>
                            <span class="edit-user-device-expand-details">
                              <label>visible:</label>
                              @if (row.get('visible')?.value) {
                                <mat-icon class="check-circle">check_circle</mat-icon>
                              }
                            </span>
                          </td>
                        </tr>
                      }
                    </ng-container>
                  }
                </tbody>
              </table>
            </form>
          </div>
        </div>
      </div>
    </form>
  }
  @if (loading) {
    <mat-spinner color="accent"></mat-spinner>
  }
</div>


